const printDesignImagePositioningConfig = [
  {
    name: 'Adult Hoodie (4200x3600)',
    width: 4200,
    height: 3600,
    positioning: [
      {
        name: 'Chest centered',
        isDefault: true,
        topOffset: 1.25,
        wideImageOffsetTop: 2.5,
        heightInInches: 9
      }
    ]
  },
  {
    name: 'Adult Sweaters (3600x3900)',
    width: 3600,
    height: 3900,
    positioning: [
      {
        name: 'Chest centered',
        isDefault: true,
        topOffset: 1.25,
        wideImageOffsetTop: 2.5,
        heightInInches: 11
      }
    ]
  },
  {
    name: 'Kids Sweaters (3300x3000)',
    width: 3300,
    height: 3000,
    positioning: [
      {
        name: 'Chest centered',
        isDefault: true,
        topOffset: 1.25,
        wideImageOffsetTop: 2.5,
        heightInInches: 7.5
      }
    ]
  },
  {
    name: 'Kids Sweaters (3600x3000)',
    width: 3600,
    height: 3000,
    positioning: [
      {
        name: 'Chest centered',
        isDefault: true,
        topOffset: 1.25,
        wideImageOffsetTop: 2.5,
        heightInInches: 7.5
      }
    ]
  },
  {
    name: 'Adult shirts/sweaters (4200x4800)',
    width: 4200,
    height: 4800,
    positioning: [
      {
        name: 'Chest centered',
        isDefault: true,
        topOffset: 2.5,
        wideImageOffsetTop: 4,
        heightInInches: 11
      }
    ]
  },
  {
    name: 'Kids shirts (3600x4200)',
    width: 3600,
    height: 4200,
    positioning: [
      {
        name: 'Chest centered',
        isDefault: true,
        topOffset: 2.5,
        wideImageOffsetTop: 4,
        heightInInches: 9
      }
    ]
  },
  {
    name: 'Womans (3300x3900)',
    width: 3300,
    height: 3900,
    positioning: [
      {
        name: 'Chest centered',
        isDefault: true,
        topOffset: 1.5,
        wideImageOffsetTop: 2.5,
        heightInInches: 9.5
      }
    ]
  },
  {
    name: 'Toddler (2400x2400)',
    width: 2400,
    height: 2400,
    positioning: [
      {
        name: 'Chest centered',
        isDefault: true,
        topOffset: 1.25,
        wideImageOffsetTop: 2.25,
        heightInInches: 5.5
      }
    ]
  },
  {
    name: 'Toddler (1800x2400)',
    width: 1800,
    height: 2400,
    positioning: [
      {
        name: 'Chest centered',
        isDefault: true,
        topOffset: 1.25,
        wideImageOffsetTop: 2.25,
        heightInInches: 5.5
      }
    ]
  },
  {
    name: 'Toddler (2100x2700)',
    width: 2100,
    height: 2700,
    positioning: [
      {
        name: 'Chest centered',
        isDefault: true,
        topOffset: 1.25,
        wideImageOffsetTop: 2.25,
        heightInInches: 6
      }
    ]
  },
  {
    name: 'Tote bag',
    uuids: ['129', '130'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 7.5
      }
    ]
  },
  {
    name: 'Mugs 11oz (2700x1125)',
    width: 2700,
    height: 1125,
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 3.25
      }
    ]
  },
  {
    name: 'Mugs 20oz (3000x1275)',
    width: 3000,
    height: 1275,
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 3.5
      }
    ]
  },
  {
    name: 'Shot glass',
    uuids: ['154'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 1.25
      }
    ]
  },
  {
    name: 'Lattee mug 12oz',
    uuids: ['243'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 3
      }
    ]
  },
  {
    name: 'Postcards',
    uuids: ['265'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 3.5
      }
    ]
  },
  {
    name: 'Mousepad',
    uuids: ['249'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 6.5
      }
    ]
  },
  {
    name: 'Trucker cap',
    uuids: ['141'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 2
      }
    ]
  },
  {
    name: 'snapback/baseball hat',
    uuids: ['17', '140'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 1.75
      }
    ]
  },
  {
    name: 'Stein mug',
    uuids: ['183'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 2.5
      }
    ]
  },
  {
    name: 'Aluminum ornament',
    uuids: ['190'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        topOffset: 1.25,
        heightInInches: 1.75
      }
    ]
  },
  {
    name: 'Round ceramic ornament',
    uuids: ['192'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 1.85
      }
    ]
  },
  {
    name: 'Button magnet',
    uuids: ['261'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 1.6
      }
    ]
  },
  {
    name: 'Cork black coaster',
    uuids: ['251'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 2.75
      }
    ]
  },
  {
    name: 'Blanket',
    uuids: ['153', '173'],
    positioning: [
      {
        name: 'Bottom left',
        isDefault: true,
        heightInInches: 12,
        widthInInches: 12,
        bottomOffset: 2.5,
        leftOffset: 2.5
      }
    ]
  },
  {
    name: 'Car magnet',
    uuids: ['170'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 4.75
      }
    ]
  },
  {
    name: 'Skate mat',
    uuids: ['253'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 12
      }
    ]
  },
  {
    name: 'Water Bottle',
    uuids: ['24', '177', '248'],
    positioning: [
      {
        name: 'Centered',
        isDefault: true,
        heightInInches: 5
      }
    ]
  }
];

export { printDesignImagePositioningConfig };
